"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Breadcrumb_styled_exports = {};
__export(Breadcrumb_styled_exports, {
  StyledBreadcrumParagraph: () => StyledBreadcrumParagraph,
  StyledBreadcrumb: () => StyledBreadcrumb,
  StyledBreadcrumbAnchor: () => StyledBreadcrumbAnchor,
  StyledBreadcrumbItem: () => StyledBreadcrumbItem,
  StyledBreadcrumbList: () => StyledBreadcrumbList,
  StyledDropdownContent: () => StyledDropdownContent,
  StyledIcon: () => StyledIcon,
  StyledIconButton: () => StyledIconButton,
  StyledPopover: () => StyledPopover,
  StyledSeparator: () => StyledSeparator
});
module.exports = __toCommonJS(Breadcrumb_styled_exports);
var import_styled_components = __toESM(require("styled-components"));
var import_atoms = require("../../atoms");
var import__ = require("./..");
var StyledBreadcrumb = import_styled_components.default.nav.withConfig({
  displayName: "Breadcrumbstyled__StyledBreadcrumb",
  componentId: "sc-1h0soaq-0"
})(function(_ref) {
  var theme = _ref.theme;
  return (0, import_styled_components.css)(["padding:", ";margin:", ";"], theme.measurements.zero, theme.measurements.zero);
});
var StyledBreadcrumbList = import_styled_components.default.ol.withConfig({
  displayName: "Breadcrumbstyled__StyledBreadcrumbList",
  componentId: "sc-1h0soaq-1"
})(function(_ref2) {
  var theme = _ref2.theme;
  return (0, import_styled_components.css)(["display:inline-flex;flex-wrap:nowrap;list-style-type:none;margin:", ";padding:", ";"], theme.measurements.zero, theme.measurements.zero);
});
var StyledDropdownContent = (0, import_styled_components.default)(import__.DropdownContent).withConfig({
  displayName: "Breadcrumbstyled__StyledDropdownContent",
  componentId: "sc-1h0soaq-2"
})(function(_ref3) {
  var theme = _ref3.theme;
  return (0, import_styled_components.css)(["margin:", ";position:relative;"], theme.measurements.zero);
});
var StyledBreadcrumbItem = import_styled_components.default.li.withConfig({
  displayName: "Breadcrumbstyled__StyledBreadcrumbItem",
  componentId: "sc-1h0soaq-3"
})(function(_ref4) {
  var theme = _ref4.theme;
  return (0, import_styled_components.css)(["padding:", ";margin:", ";display:flex;align-items:center;"], theme.measurements.zero, theme.measurements.zero);
});
var StyledIcon = (0, import_styled_components.default)(import_atoms.Icon).withConfig({
  displayName: "Breadcrumbstyled__StyledIcon",
  componentId: "sc-1h0soaq-4"
})(function(_ref5) {
  var theme = _ref5.theme, variant = _ref5.variant;
  return (0, import_styled_components.css)(["padding-top:", ";margin:", " ", ";font-size:", ";"], theme.measurements.small, theme.measurements.zero, theme.measurements.extraSmall, variant === "big" ? theme.iconology.sizes.medium : theme.iconology.sizes.small);
});
var getBreadcrumbItemColor = function getBreadcrumbItemColor2(_ref6) {
  var theme = _ref6.theme, darkMode = _ref6.darkMode, linkColor = _ref6.linkColor;
  if (linkColor) {
    return linkColor;
  }
  return darkMode ? theme.colors.beige[120] : theme.colors.pr.base;
};
var getDisabledColor = function getDisabledColor2(theme, darkMode) {
  return darkMode ? theme.colors.white : theme.colors.n[100];
};
var StyledBreadcrumbAnchor = import_styled_components.default.a.withConfig({
  displayName: "Breadcrumbstyled__StyledBreadcrumbAnchor",
  componentId: "sc-1h0soaq-5"
})(function(_ref7) {
  var linkColor = _ref7.linkColor, currentItemColor = _ref7.currentItemColor, _ref7$textDecoration = _ref7.textDecoration, textDecoration = _ref7$textDecoration === void 0 ? "underline" : _ref7$textDecoration, _ref7$textTransform = _ref7.textTransform, textTransform = _ref7$textTransform === void 0 ? "none" : _ref7$textTransform, _ref7$variant = _ref7.variant, variant = _ref7$variant === void 0 ? "big" : _ref7$variant, darkMode = _ref7.darkMode, theme = _ref7.theme, disabled = _ref7.disabled;
  return (0, import_styled_components.css)(["display:inline-flex;align-items:center;text-decoration:none;border:1px solid transparent;box-sizing:border-box;line-height:", ";cursor:", ";font-family:", ";font-size:", ";font-weight:", ";color:", ";:hover{color:", ";}:focus,:focus-visible{color:", ";border-color:", ";border-radius:", ";outline:none;}:active{color:", ";}& > *{color:inherit;}& > span{text-decoration:", ";text-transform:", ";margin:", " ", ";white-space:nowrap;}&[disabled]{color:", ";}&[aria-current='page']{color:", ";}&[disabled],&[aria-current='page']{cursor:not-allowed;span{text-decoration:none;pointer-events:none;cursor:'not-allowed';}}"], variant === "big" ? "24px" : "21px", disabled ? "not-allowed" : "pointer", theme.typography.fonts.primary, variant === "big" ? theme.typography.sizes.small : theme.typography.sizes.extraSmall, theme.typography.weights.regular, getBreadcrumbItemColor({
    theme,
    darkMode,
    linkColor
  }), darkMode ? theme.colors.white : theme.colors.pr[180], darkMode ? theme.colors.white : theme.colors.pr.base, darkMode ? theme.colors.beige[160] : theme.colors.beige[180], theme.measurements.small, darkMode ? theme.colors.beige[60] : theme.colors.beige[180], textDecoration, textTransform, theme.measurements.zero, theme.measurements.extraSmall, getDisabledColor(theme, darkMode), currentItemColor || getDisabledColor(theme, darkMode));
});
var StyledBreadcrumParagraph = import_styled_components.default.span.withConfig({
  displayName: "Breadcrumbstyled__StyledBreadcrumParagraph",
  componentId: "sc-1h0soaq-6"
})(function(_ref8) {
  var theme = _ref8.theme, _ref8$variant = _ref8.variant, variant = _ref8$variant === void 0 ? "big" : _ref8$variant, darkMode = _ref8.darkMode;
  return (0, import_styled_components.css)(["display:flex;line-height:", ";font-family:", ";font-size:", ";font-weight:", ";border:1px solid transparent;margin:", " ", ";color:", ";"], variant === "big" ? "24px" : "21px", theme.typography.fonts.primary, variant === "big" ? theme.typography.sizes.small : theme.typography.sizes.extraSmall, theme.typography.weights.regular, theme.measurements.zero, theme.measurements.extraSmall, darkMode ? theme.colors.white : theme.colors.black);
});
var StyledSeparator = import_styled_components.default.span.withConfig({
  displayName: "Breadcrumbstyled__StyledSeparator",
  componentId: "sc-1h0soaq-7"
})(function(_ref9) {
  var theme = _ref9.theme, darkMode = _ref9.darkMode, variant = _ref9.variant;
  return (0, import_styled_components.css)(["display:inline-flex;align-items:center;justify-content:center;width:", ";height:", ";font-size:24px;color:", ";"], theme.measurements.medium, variant === "big" ? "32px" : "24px", darkMode ? theme.colors.beige[160] : theme.colors.beige[180]);
});
var getEllipsisColor = function getEllipsisColor2(theme, color, darkMode) {
  if (color) {
    return color;
  }
  return darkMode ? theme.colors.beige[120] : theme.colors.pr.base;
};
var StyledIconButton = (0, import_styled_components.default)(import__.IconButton).withConfig({
  displayName: "Breadcrumbstyled__StyledIconButton",
  componentId: "sc-1h0soaq-8"
})(function(_ref10) {
  var theme = _ref10.theme, darkMode = _ref10.darkMode, color = _ref10.color, readOnly = _ref10.readOnly;
  return (0, import_styled_components.css)(["width:24px;height:24px;background-color:transparent;border:1px solid transparent;border-radius:", ";padding:", " ", ";box-sizing:border-box;i{color:", ";text-decoration:", ";}:hover{background-color:", ";border-color:", ";i{color:", ";}}:focus,:focus-visible{outline:none;border-color:", ";box-shadow:none;}:active{background-color:", ";border-color:", ";text-decoration:none;i{color:", ";}}"], theme.measurements.small, theme.measurements.extraSmall, theme.measurements.zero, readOnly ? theme.colors.black : getEllipsisColor(theme, color, darkMode), readOnly ? "none" : "underline", darkMode ? "transparent" : theme.colors.beige[40], darkMode ? theme.colors.beige[160] : theme.colors.beige[180], readOnly ? theme.colors.black : darkMode ? theme.colors.white : theme.colors.pr.base, darkMode ? theme.colors.beige[160] : theme.colors.beige[180], darkMode ? "transparent" : theme.colors.beige[40], darkMode ? theme.colors.beige[160] : theme.colors.pr.base, darkMode ? theme.colors.beige[60] : theme.colors.n[100]);
});
var StyledPopover = (0, import_styled_components.default)(import_atoms.Popover).withConfig({
  displayName: "Breadcrumbstyled__StyledPopover",
  componentId: "sc-1h0soaq-9"
})(function() {
  return (0, import_styled_components.css)(["max-width:fit-content;box-sizing:border-box;margin-left:2px;ol{flex-wrap:wrap;}"]);
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  StyledBreadcrumParagraph,
  StyledBreadcrumb,
  StyledBreadcrumbAnchor,
  StyledBreadcrumbItem,
  StyledBreadcrumbList,
  StyledDropdownContent,
  StyledIcon,
  StyledIconButton,
  StyledPopover,
  StyledSeparator
});
//# sourceMappingURL=Breadcrumb.styled.js.map